import { render, staticRenderFns } from "./ButtonRemove.vue?vue&type=template&id=3c071f3a&scoped=true&"
import script from "./ButtonRemove.vue?vue&type=script&lang=js&"
export * from "./ButtonRemove.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c071f3a",
  null
  
)

export default component.exports